module.exports = __webpack_public_path__ + "static/media/light-motion-sequence.21cede8.mp4";